import React from 'react'
import { observer } from 'mobx-react'

const ModalButtons = ({
  hideButtons,
  close,
  onOk,
  onCancel,
  okText,
  cancelText,
  hideOkButton,
  hideCancelButton
}) => {
  if (hideButtons) return null

  const onOkCb = onOk || close
  const onCancelCb = onCancel || close

  const okButton = !hideOkButton ? (
    <button className='button button--primary' onClick={onOkCb}>
      {okText || 'OK'}
    </button>
  ) : null

  const cancelButton = !hideCancelButton ? (
    <button className='button button--secondary' onClick={onCancelCb}>
      {cancelText || 'Cancel'}
    </button>
  ) : null

  console.log('hideCancelButton', hideCancelButton)

  return (
    <div className='modal__buttons'>
      {okButton}
      {cancelButton}
    </div>
  )
}

export default observer(ModalButtons)
